/* eslint-disable import/no-named-as-default-member */
import _ from "lodash";
import { Dialog, DialogContent, IconButton, InputAdornment, Select, MenuItem, InputLabel, CircularProgress, FormControl } from "@material-ui/core";
import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import MaterialDatePicker from "material-ui-pickers/DatePicker";
import EventIcon from "@material-ui/icons/Event";
import moment from "moment";
import { VersitileInput } from "components/Global/Fields/VersitileInput";
import PrimaryButton from 'components/Global/Buttons/PrimaryButton';
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';
import numberFormatter from "utils/numberFormatter";
import {getSupCalcInfo } from "store/state/companies";
import {calculateSuppPricer, calculateSuppPricerCalculating} from "store/state/calculators/suppPricer";

const LOANBOSS_PURP = "rgb(45, 98, 162)";
const LOANBOSS_RED = "#D9001B";

const MIN_SUPP_AMOUNT_CALCULATION_CONFIG_ITEM_ID = "bd397e48-1d5f-4fa9-9c28-eb22d9a90c9d";

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

const StyledDialog = styled(Dialog)`
  &&& {
    min-width: 700px;
  }
`;

const StyledDialogContent = styled(DialogContent)`
  && {
    padding: 28px;
    min-height: 645px;
    overflow-x: hidden;
    overflow-y: auto;
  }
`;

const ModalTitle = styled.p`
  font-weight: normal;
  font-size: 17pt;
  margin-left: 20px;
`;

const StyledSpinner = styled(CircularProgress)`
  position: absolute;
  left: 435px;
`
const PrettyTable = styled.table`
border-spacing: 0px;
`

const GreyHeader = styled.tr`
background-color: #f9f9f9;
color: black
`

const HeaderCell = styled.th`
&& {
    border-bottom: 3px solid #eeeeee;
    font-weight: normal;
    font-size: 18;
    width: 100px;
    text-align: center;
}
`
const UpperHeaderCell = styled.th`
&& {
    border-bottom: 1px solid #aaaaaa;
    font-weight: bold;
    font-size: 18;
    text-align: center;
}
`


const UniformCell = styled.td`
    width: 100px !important;
    border-bottom: 1px solid #eeeeee;
    padding-top: 5px;
    padding-bottom: 5px;
    text-align: center;
`;

const ErrorTextbox = styled.div`
  color: orange;
  font-weight: bold;
  margin-bottom: 5px;
`

class ChangeDealStatusModal extends Component {
   state = {
     isShortTerm: true,
    calculationDate: new Date(),
    dealId: "",
    rateType: null,
    shockScenario: "MARKET_EXPECTATIONS",
    shockValue: 0.0,
    errorMessage: null,
    showingAdditionalInformation: false,
    result: {
      supplementalLoanProceeds: 1000000,  //numbers are placeholders. Will need to receive from API
      underWrittenRate: .0675,
      totalLoanProceeds: 500000,
      weightedAverageInterestRate: .0525,
    },
}
  componentDidUpdate(prevProps) {
    if(!this.state.rateType && this.props.rateTypePrefill){
      this.setState({
        rateType: this.props.rateTypePrefill
      })
      this.callSuppPricer(this.props.rateTypePrefill);
    }
  }

  componentDidMount() {
    this.props.getSupCalcInfo();
  }

  cleanClose = () => {
      this.props.handleClose();
  }

  callSuppPricer = (rateTypePrefill) => {
    const { calculationDate, rateType, shockScenario, shockValue, projectedNoi } = this.state;
    let shock = 0.0;
    if(shockScenario === "PARALLEL")
      shock = shockValue/10000;
    else if(shockScenario === "STANDARD_DEVIATION")
      shock = shockValue;
    const rateTypeVal = rateType || rateTypePrefill
    const payload = {calculationDate, dealId: this.props.deal.id, rateType: rateTypeVal, shockType: shockScenario, shockValue: shock, includeConfig: false, projectedNOI: projectedNoi, callback: this.props.calculateSuppPricerCalculating};
    if(!this.props.isShortTerm){
      this.props.calculateSuppPricerCalculating({isCalculating: true});
      this.props.calculateSuppPricer(payload);
    }
  }


  render() {
    const { isOpen, handleClose } = this.props;
    this.generateErrorMessage();
    return (
      <StyledDialog
        modal
        maxWidth="md"
        fullWidth
        open={isOpen}
        autoDetectWindowHeight={false}
        autoScrollBodyContent={false}
        contentStyle={{ width: "700px", maxWidth: "none" }}
        onClose={() => this.cleanClose()}
      >
        <ModalTitle>Supplemental Calculator</ModalTitle>
        <StyledDialogIconButton onClick={() => this.cleanClose()}>
          <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
        </StyledDialogIconButton>
        <StyledDialogContent>
            <div style={{marginBottom: "20px"}}>
                <MaterialDatePicker
                    format = "MM/DD/YYYY"
                    keyboard={true}
                    value = {this.state.calculationDate}
                    style = {{marginLeft: "20px", backgroundColor: "white"}}
                    onChange = { event => {
                        this.setState({calculationDate: event});
                    }}
                    clearable={true}
                    disableOpenOnEnter
                    label = "Calculation Date"
                    InputProps={{
                        endAdornment: <InputAdornment position="start"><EventIcon /></InputAdornment>,
                      }}
                />
                <VersitileInput 
                    style = {{marginLeft: "30px", marginRight:"30px"}}
                    type = "decimal"
                    internalLabel = "Projected NOI"
                    defaultValue = {this.props.noiPrefill || 0}
                    onBlur = {value => {
                        this.setState({projectedNoi: value});
                    }}
                />
                <FormControl>
                    <InputLabel shrink htmlFor="rateType">Rate Type</InputLabel>
                    <Select
                    style = {{minWidth: "150px"}}
                    value = {this.state.rateType}
                    onChange = {event => {
                        this.setState({rateType: event.target.value});
                    }}
                    name = "rateType"
                    >
                        <MenuItem value={"FIXED"}>Fixed</MenuItem>
                        <MenuItem value={"FLOATING"}>Floating</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div style={{paddingLeft: "15px", borderBottom: "1px solid #aaaaaa", paddingBottom: "10px"}}>
            <FormControl>
                    <InputLabel shrink htmlFor="shockScenario">Shock Scenario</InputLabel>
                    <Select
                    style = {{minWidth: "170px", marginRight: "30px"}}
                    value = {this.state.shockScenario}
                    onChange = {event => {
                        this.setState({shockScenario: event.target.value});
                    }}
                    name = "shockScenario"
                    >
                        <MenuItem value={"MARKET_EXPECTATIONS"}>Market Expectations</MenuItem>
                        <MenuItem value={"PARALLEL"}>Parallel Shift</MenuItem>
                        <MenuItem value={"STANDARD_DEVIATION"}>Standard Deviation</MenuItem>
                    </Select>
                </FormControl>
                {this.renderShockField()}
                <PrimaryButton style={{float: "right", marginRight: "30px"}} disabled={this.props.isCalculating} onClick={this.callSuppPricer}>
                    Calculate
                </PrimaryButton>
            </div>
            <div style={{textAlign: "center"}}>
                    {this.renderReceipt()}
            </div>
        </StyledDialogContent>
      </StyledDialog>
    );
  }

  renderReceipt = () => {
      if(!this.props.result) {
          return null;
      }



      return (
          <div style={{padding: "15px"}}>
            {this.props.isCalculating && <StyledSpinner size={75} thickness={1} />}
                {this.state.showingAdditionalInformation && this.renderInfoTables()} 
                {!this.state.showingAdditionalInformation && this.props.result.isQualified && this.renderCalculationOutput()}
                {!this.state.showingAdditionalInformation && !this.props.result.isQualified && this.renderIncreaseNeededCalculationOutput()}
                {this.renderAdditionalInformationButton()}
                <span style={{fontSize: "14px", color: "#777777"}}>Calculations are for informational purposes and subject to change with market conditions.</span>
          </div>
      )
  }

  renderCalculationOutput = () => {
    return (
        <>
        <ErrorTextbox>{this.state.errorMessage}</ErrorTextbox>
        {!this.state.isShortTerm && this.props.result && this.props.result.combinedSuppBalance &&
        (<><div style={{
                        width: "300px",
                        padding:"15px",
                        paddingTop:"20px",
                        border: `1px solid ${LOANBOSS_PURP}`,
                        display: "inline-block",
                        marginBottom:"25px"}}>
                            <span style={{fontSize: "40px"}}>{numberFormatter.formatMoney(this.props.result.combinedSuppBalance,0)}</span>
                            <br/>
                            <span style={{fontSize: "12px", color: LOANBOSS_PURP}}>SUPPLEMENTAL LOAN PROCEEDS</span>
                            <br/>
                            <div style= {{paddingTop:"30px"}}></div>
                            <span style={{fontSize: "40px"}}>{numberFormatter.formatRate(this.props.result.uwRate,2)}</span>
                            <br/>
                            <span style={{fontSize: "12px", color: LOANBOSS_PURP}}>UNDERWRITTEN RATE</span>
                    </div>
                    <br/>
                    <span style={{fontSize: "30px"}}>{numberFormatter.formatMoney(this.props.result.combinedCumulativeBal,2)}</span>
                    <br/>
                    <span style={{fontSize: "12px", color: LOANBOSS_PURP}}>TOTAL LOAN PROCEEDS</span>
                    <br/>
                    <div style= {{paddingTop:"25px"}}></div>
                    <span style={{fontSize: "30px"}}>{numberFormatter.formatRate(this.props.result.wair,2)}</span>
                    <br/>
                    <span style={{fontSize: "12px", color: LOANBOSS_PURP}}>WEIGHTED AVERAGE INTEREST RATE</span>
                    <br/>
                    <span style={{fontSize: "12px", color: "#999999"}}>This is an estimate only, you must contact your broker to get precise numbers.</span>
                    <div style={{height: "30px"}}></div>
                    </>)}
                    </>
        )
  }
  renderIncreaseNeededCalculationOutput = () => {
    return (
        <>
        <ErrorTextbox>{this.state.errorMessage}</ErrorTextbox>
        {!this.state.isShortTerm && this.props.result  && this.props.result.CombinedRequireNOI
          && (
          <>
            <div style={{
                            width: "300px",
                            padding:"15px",
                            paddingTop:"20px",
                            border: `1px solid ${LOANBOSS_PURP}`,
                            display: "inline-block",
                            marginBottom:"25px"}}>
                                <span style={{fontSize: "40px"}}>{numberFormatter.formatMoney(this.props.result.CombinedRequireNOI,0)}</span>
                                <br/>
                                <span style={{fontSize: "12px", color: LOANBOSS_RED}}>REQUIRED NOI COMBINED</span>
                        </div>
                        <br/>
                        <span style={{fontSize: "30px"}}>{numberFormatter.formatMoney(this.props.result.CombinedIncreaseNeeded,0)}</span>
                        <br/>
                        <span style={{fontSize: "12px", color: LOANBOSS_RED}}>INCREASED NEEDED COMBINED</span>
                        <br/>
                        <div style= {{paddingTop:"25px"}}></div>
                        <span style={{fontSize: "30px"}}>{numberFormatter.formatMoney(this.props.result.periodNOI,0)}</span>
                        <br/>
                        <span style={{fontSize: "12px", color: LOANBOSS_RED}}>CURRENT NOI COMBINED</span>
                        <br/>
                        <span style={{fontSize: "12px", color: "#999999"}}>This is an estimate only, you must contact your broker to get precise numbers.</span>
                        <div style={{height: "30px"}}></div>
          </>
        )}
        </>
        )
  }

  renderAdditionalInformationButton = () => {
    let sai = this.state.showingAdditionalInformation;
    return (
        <>
        <br/><div 
        style={{display: "inline-block", color: "#777777", marginTop: "0px", marginBottom: "20px", cursor: "pointer"}}
        onClick = {()=>{this.setState({showingAdditionalInformation: !sai})}}
        >
            {sai ?  <b>{"<"}</b> : ""} {sai ? "HIDE" : "SHOW"} ADDITIONAL INFORMATION {!sai ?  <b>{">"}</b> : ""}
        </div>
        <br/>
        </>
    )
  }

  renderInfoTables = () => {
      return (
          <>
          {this.renderCreditGuidanceTable()}
          {this.renderPricingColorTable()}
          </>
      )
  }

  renderPricingColorTable = () => {
    return (
        <>
         <div style = {{textAlign: "left"}}>
        <span style={{color:"#888888", fontSize: "20px"}}>WEEKLY PRICING COLOR</span>
        </div>
        <PrettyTable style={{marginBottom: "0px"}}> 
            <GreyHeader>
                <td colSpan={2}></td>
                <UpperHeaderCell colSpan={2}>Tier 1</UpperHeaderCell>
                <UpperHeaderCell colSpan={2}>Tier 2</UpperHeaderCell>
                <UpperHeaderCell colSpan={2}>Tier 3</UpperHeaderCell>
            </GreyHeader>
            <GreyHeader>
                <UpperHeaderCell colSpan={2}>Term (m)</UpperHeaderCell>
                <UpperHeaderCell>DSCR</UpperHeaderCell>
                <UpperHeaderCell>LTV</UpperHeaderCell>
                <UpperHeaderCell>DSCR</UpperHeaderCell>
                <UpperHeaderCell>LTV</UpperHeaderCell>
                <UpperHeaderCell>DSCR</UpperHeaderCell>
                <UpperHeaderCell>LTV</UpperHeaderCell>
            </GreyHeader>
            <GreyHeader>
                <HeaderCell>Max</HeaderCell>
                <HeaderCell>Min</HeaderCell>
                <HeaderCell>{this.props.tiers.filter(x=>x.tier===1)[0].DSCR || "-"}x</HeaderCell>
                <HeaderCell>{this.props.tiers.filter(x=>x.tier===1)[0].LTV*100 || "-"}%</HeaderCell>
                <HeaderCell>{this.props.tiers.filter(x=>x.tier===2)[0].DSCR || "-"}x</HeaderCell>
                <HeaderCell>{this.props.tiers.filter(x=>x.tier===2)[0].LTV*100 || "-"}%</HeaderCell>
                <HeaderCell>{this.props.tiers.filter(x=>x.tier===3)[0].DSCR || "-"}x</HeaderCell>
                <HeaderCell>{this.props.tiers.filter(x=>x.tier===3)[0].LTV*100 || "-"}%</HeaderCell>
            </GreyHeader>
            {this.renderTierRows()}
    </PrettyTable>
        </>
    )
  }

  renderTierRows = () => {
    let inputStyle = {maxWidth: '80px'}
    let out = [];
    let values = this.getTierValueRows(this.props.tierValues);
    values.forEach(record => {
        out.push(<tr>
            <UniformCell>
                {record.maxTerm}
            </UniformCell>
            <UniformCell>
               {record.minTerm}
            </UniformCell>
            <UniformCell colSpan={2}>
                {record.tier1Value ? numberFormatter.formatRate(record.tier1Value,2) : "-"}
            </UniformCell>
            <UniformCell colSpan={2}>
                {record.tier2Value ? numberFormatter.formatRate(record.tier2Value,2) : "-"}
            </UniformCell>
            <UniformCell colSpan={2}>
                {record.tier3Value ? numberFormatter.formatRate(record.tier3Value,2) : "-"}
            </UniformCell>
        </tr>)
    });
    return out;
  }

  getTierValueRows = (tierValues) => {
    let values = _.orderBy(tierValues, "sortOrder", "asc");
    let out = [];
    for (let i = 0; i < tierValues.length; i+=3){
        let record = {};
        record.maxTerm = values[i].maxTerm;
        record.minTerm = values[i].minTerm;
        record.tier1Value = values[i].value;
        record.tier2Value = values[i+1].value;
        record.tier3Value = values[i+2].value;
        record.ids = [values[i].id, values[i+1].id, values[i+2].id];
        out.push(record);
    }
    return out;
}

  renderCreditGuidanceTable = () => {
    return (
        <>
        <div style = {{textAlign: "left", paddingTop: "10px"}}>
        <span style={{color:"#888888", fontSize: "20px"}}>CREDIT GUIDANCE</span>
         <PrettyTable style={{marginBottom: "30px"}}>
            <GreyHeader>
                <UpperHeaderCell colSpan={2}>Term (m)</UpperHeaderCell>
                <UpperHeaderCell colSpan={2}>Amort</UpperHeaderCell>
                <UpperHeaderCell colSpan={2}>Partial IO</UpperHeaderCell>
                <UpperHeaderCell colSpan={2}>Full IO</UpperHeaderCell>
            </GreyHeader>
            <GreyHeader>
                <HeaderCell>Max</HeaderCell>
                <HeaderCell>Min</HeaderCell>
                <HeaderCell>DSCR</HeaderCell>
                <HeaderCell>LTV</HeaderCell>
                <HeaderCell>DSCR</HeaderCell>
                <HeaderCell>LTV</HeaderCell>
                <HeaderCell>DSCR</HeaderCell>
                <HeaderCell>LTV</HeaderCell>
            </GreyHeader>
            {this.renderCreditGuidanceRows()}
        </PrettyTable>
        </div>
        </>
    )
  }

  renderCreditGuidanceRows = () => {
    return _.orderBy(this.props.creditGuidanceValues, "maxTerm", "desc").map(x=>{
        return (<tr>
            <UniformCell>{x.maxTerm}</UniformCell>
            <UniformCell>{x.minTerm}</UniformCell>
            <UniformCell>{x.amortDSCR ? `${numberFormatter.formatDecimal(x.amortDSCR,2)}x` : "-"}</UniformCell>
            <UniformCell>{x.amortLTV ? numberFormatter.formatRate(x.amortLTV,2) : "-"}</UniformCell>
            <UniformCell>{x.partialIoDSCR ? `${numberFormatter.formatDecimal(x.partialIoDSCR,2)}x` : "-"}</UniformCell>
            <UniformCell>{x.partialIoLTV ? numberFormatter.formatRate(x.partialIoLTV,2) : "-"}</UniformCell>
            <UniformCell>{x.fullIoDSCR ? `${numberFormatter.formatDecimal(x.fullIoDSCR,2)}x` : "-"}</UniformCell>
            <UniformCell>{x.fullIoLTV ? numberFormatter.formatRate(x.fullIoLTV,2) : "-"}</UniformCell>
        </tr>)
    })
  }
  

  renderShockField = () => {
      if(this.state.shockScenario === "PARALLEL") {
        return (
            <VersitileInput
                style={{minWidth:"200px", maxWidth:""}} 
                internalLabel = "Parallel Shift Amount (bps)"
                type = "decimal"
                value = {this.state.shockValue}
                onChange = {value => this.setState({shockValue: value})}
            />
        )
      }
      if(this.state.shockScenario === "STANDARD_DEVIATION") {
        return (
            <VersitileInput
                style={{minWidth:"200px", maxWidth:""}} 
                internalLabel = "Standard Deviations"
                type = "decimal"
                value = {this.state.shockValue}
                onChange = {value => this.setState({shockValue: value})}
            />
        )
      }
  }

  generateErrorMessage = () => {
    if(this.props.loanToUse && this.props.loanToUse.closingDate){
      let currentDate = this.state.calculationDate;
      let closingDate = new Date(this.props.loanToUse.closingDate);
      closingDate.setFullYear(parseInt(closingDate.getFullYear()+1));
      if(currentDate < closingDate){
        let newErrorMessage = `You are not qualified for a Supplemental Loan until ${moment.utc(closingDate).format("MM/DD/YYYY")}`;
        if(newErrorMessage !== this.state.errorMessage){
          this.setState({
            errorMessage: newErrorMessage,
            isShortTerm: true,
          });
        }
        return null;
      }
    }
    if(this.props.mostRecentSupplemental && this.props.mostRecentSupplemental.closingDate){
      let currentDate = this.state.calculationDate;
      let closingDate = new Date(this.props.mostRecentSupplemental.closingDate);
      closingDate.setFullYear(parseInt(closingDate.getFullYear()+1));
      if(currentDate < closingDate){
        let newErrorMessage = `You are not qualified for a Supplemental Loan until ${moment.utc(closingDate).format("MM/DD/YYYY")}`;
        if(newErrorMessage !== this.state.errorMessage){
          this.setState({
            errorMessage: newErrorMessage,
            isShortTerm: true,
          });
        }
        return null;
      }
    }
    if(this.props.loanToUse && this.props.calculationConfigItems && this.props.result && this.props.result.supplementalLoanProceeds){
      let minAmount = this.props.calculationConfigItems.filter(x=>x.id===MIN_SUPP_AMOUNT_CALCULATION_CONFIG_ITEM_ID)[0].value;
      if(this.props.result.supplementalLoanProceeds < minAmount){
        let newErrorMessage = `Supplemental loan amount is below ${numberFormatter.formatMoney(minAmount,0)}`;
        if(newErrorMessage !== this.state.errorMessage){
          this.setState({
            errorMessage: newErrorMessage,
            isShortTerm: false,
          });
        }
        return null;
      }
    }
    if(this.props.loanToUse && this.props.loanToUse.maturityDate){
      let currentDate = this.state.calculationDate;
      let maturityDate = new Date(this.props.loanToUse.maturityDate);
      maturityDate.setFullYear(parseInt(maturityDate.getFullYear()-3));
      if(currentDate > maturityDate){
        let newErrorMessage = `You are not qualified for a Supplemental Loan because the original loan is within 3 years of maturity`;
        if(newErrorMessage !== this.state.errorMessage){
          this.setState({
            errorMessage: newErrorMessage,
            isShortTerm: true,
          });
        }
        return null;
      }
    }
    if(this.props.result && this.props.result.success && !this.props.result.isQualified && this.state.isShortTerm){
      const newErrorMessage = `You are not qualified for a Supplemental Loan until NOI Increase is met.`;
        if(newErrorMessage !== this.state.errorMessage){
          this.setState({ 
            errorMessage: newErrorMessage,
            isShortTerm: false, 
          });
      }
      return null;
    }

    if(this.state.errorMessage || (!this.state.errorMessage && this.state.isShortTerm)){
      this.setState({
        errorMessage: null, 
        isShortTerm: false
      })
    }
  }

}


function mapStateToProps({ authentication, companies, calculators }) {
  return {
    authentication,
    result: calculators.suppPricer ? calculators.suppPricer.suppPricerResult : {},
    isCalculating: calculators.suppPricer ? calculators.suppPricer.isCalculating : false,
    ...companies.supCalcSettings
  };
}

export default compose(
  connect(mapStateToProps, {
    calculateSuppPricer,
    getSupCalcInfo,
    calculateSuppPricerCalculating
  })
)(ChangeDealStatusModal);
